import { render, staticRenderFns } from "./centers.vue?vue&type=template&id=3d70be98"
import script from "./centers.vue?vue&type=script&lang=js"
export * from "./centers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports